import React, { useCallback, useEffect, useState } from 'react';
import { useProductScanner, Product } from '../hooks/useProductScanner';
const NAMES = ['María', 'Carlos', 'Valentina', 'Diego', 'Camila', 'Andrés', 'Lucía', 'Mateo', 'Sofía', 'Sebastián', 'Paula', 'Nicolás', 'Florencia', 'Tomás', 'Carolina'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Bogotá', 'Medellín', 'Lima', 'Santiago', 'Montevideo', 'CDMX', 'Guadalajara', 'Quito'];
interface ToastData {
  name: string;
  city: string;
  timeAgo: number;
  product: Product;
}
export function RecentPurchaseToast() {
  const products = useProductScanner();
  const [isVisible, setIsVisible] = useState(false);
  const [toastData, setToastData] = useState<ToastData | null>(null);
  const getRandomItem = <T,>(arr: T[]): T => arr[Math.floor(Math.random() * arr.length)];
  const getRandomInt = (min: number, max: number) => Math.floor(Math.random() * (max - min + 1)) + min;
  const generateToastData = useCallback(() => {
    if (products.length === 0) return null;
    return {
      name: getRandomItem(NAMES),
      city: getRandomItem(CITIES),
      timeAgo: getRandomInt(1, 15),
      product: getRandomItem(products)
    };
  }, [products]);
  useEffect(() => {
    if (products.length === 0) return;
    let showTimeout: NodeJS.Timeout;
    let hideTimeout: NodeJS.Timeout;
    const scheduleNextToast = (isFirst: boolean = false) => {
      // First toast appears after 8-12s, subsequent ones after 15-25s
      const delay = isFirst ? getRandomInt(8000, 12000) : getRandomInt(15000, 25000);
      showTimeout = setTimeout(() => {
        const newData = generateToastData();
        if (newData) {
          setToastData(newData);
          setIsVisible(true);
          // Hide after 5 seconds
          hideTimeout = setTimeout(() => {
            setIsVisible(false);
            // Schedule the next one after hiding
            scheduleNextToast(false);
          }, 5000);
        } else {
          scheduleNextToast(false);
        }
      }, delay);
    };
    scheduleNextToast(true);
    return () => {
      clearTimeout(showTimeout);
      clearTimeout(hideTimeout);
    };
  }, [products, generateToastData]);
  if (!toastData) return null;
  return <div className={`fixed bottom-5 left-5 z-50 transition-all duration-500 ease-out cursor-pointer ${isVisible ? 'translate-x-0 opacity-100 pointer-events-auto' : '-translate-x-[120%] opacity-0 pointer-events-none'}`} onClick={() => setIsVisible(false)} data-id="element-266">
      <div className="bg-[#150025]/95 backdrop-blur-sm border border-[rgba(194,0,111,0.3)] rounded-xl py-3 px-4 max-w-[320px] shadow-[0_8px_30px_rgba(0,0,0,0.5),0_0_20px_rgba(194,0,111,0.15)] relative overflow-hidden group" data-id="element-267">
        <div className="flex items-start gap-3" data-id="element-268">
          {/* Thumbnail */}
          <div className="shrink-0 mt-1" data-id="element-269">
            <img src={toastData.product.thumbnailUrl} alt={toastData.product.title} className="w-10 h-10 rounded-md object-cover border border-white/10 shadow-sm" data-id="element-270" />
          </div>

          {/* Content */}
          <div className="flex-1 min-w-0 pr-4" data-id="element-271">
            <div className="flex items-center gap-1.5 mb-0.5" data-id="element-272">
              <span className="font-heading font-bold text-white text-sm truncate" data-id="element-273">
                {toastData.name} de {toastData.city}
              </span>
            </div>

            <div className="text-white/60 text-xs mb-1" data-id="element-274">
              compró{' '}
              <span className="text-magenta-bright font-heading font-bold text-sm block truncate mt-0.5" data-id="element-275">
                {toastData.product.title}
              </span>
            </div>

            <div className="flex items-center justify-between mt-1.5" data-id="element-276">
              <span className="text-gold font-heading font-bold text-sm" data-id="element-277">
                {toastData.product.priceText}
              </span>
              <span className="text-white/40 text-[0.7rem]" data-id="element-278">
                hace {toastData.timeAgo} min
              </span>
            </div>

            <div className="flex items-center gap-1 mt-1.5" data-id="element-279">
              <span className="text-green-400 text-[0.7rem] font-medium flex items-center gap-0.5" data-id="element-280">
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" data-id="element-281">
                  <polyline points="20 6 9 17 4 12" data-id="element-282"></polyline>
                </svg>
                Compra verificada
              </span>
            </div>
          </div>
        </div>

        {/* Subtle highlight effect on hover */}
        <div className="absolute inset-0 bg-gradient-to-tr from-magenta/0 to-magenta/5 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none" data-id="element-283" />
      </div>
    </div>;
}